import { useTranslation } from 'react-i18next';

interface VerticalTypeToggleProps {
  value: 'credit' | 'debit';
  onChange: (value: 'credit' | 'debit') => void;
  disabled?: boolean;
  className?: string;
}

export default function VerticalTypeToggle({
  value,
  onChange,
  disabled = false,
  className = '',
}: VerticalTypeToggleProps) {
  const { t } = useTranslation('common');
  const toggle = () => {
    if (!disabled) {
      onChange(value === 'credit' ? 'debit' : 'credit');
    }
  };

  const borderColor = value === 'credit' ? 'border-green-300' : 'border-red-300';

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={disabled}
      tabIndex={-1}
      className={`flex flex-col rounded-l-lg overflow-hidden border border-r-0 w-7 min-w-[28px] flex-shrink-0 ${borderColor} ${
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
      } ${className}`}
      title={value === 'credit' ? t('operationType.toggleToDebit') : t('operationType.toggleToCredit')}
      aria-label={t('operationType.ariaLabelVertical', { type: value === 'credit' ? t('operationType.credit') : t('operationType.debit') })}
    >
      <span
        className={`flex-1 flex items-center justify-center text-xs font-bold leading-none transition-colors duration-150 ${
          value === 'credit'
            ? 'bg-green-500 text-white'
            : 'bg-gray-100 text-gray-400'
        }`}
      >
        +
      </span>
      <span
        className={`flex-1 flex items-center justify-center text-xs font-bold leading-none transition-colors duration-150 ${
          value === 'debit'
            ? 'bg-red-500 text-white'
            : 'bg-gray-100 text-gray-400'
        }`}
      >
        −
      </span>
    </button>
  );
}
